/***********
 *   DOM   *
 ***********/

// scroll of the main
export function getMainScroll() {
  const content = document.querySelector("ion-app .ion-page ion-content");
  const shadow = content?.shadowRoot;
  const main = shadow?.querySelector("main");

  return main?.scrollTop;
}

export function setMainScroll(height: number) {
  const content = document.querySelector("ion-app .ion-page ion-content");
  const shadow = content?.shadowRoot;
  const main = shadow?.querySelector("main");

  if (main) main.scrollTop = height;
}

/***********
 *   URL   *
 ***********/

export function setQueryParam(key: string, value: number) {
  const url = new URL(window.location.toString());
  const params = new URLSearchParams(url.search);

  params.set(key, value.toString());
  url.search = params.toString();

  return url;
}

export function getQueryParam(key: string) {
  const url = new URL(window.location.toString());
  const params = new URLSearchParams(url.search);

  return params.get(key);
}
